import styled from 'styled-components';

export const ContainerCor = styled.div`
  padding: 10px;
`;

export const Titulo = styled.h1`
  color: var(--texto-color);
  text-align: center;
`;

export const Label = styled.label`
  font-weight: 500;
  margin-left: 3px;
`;

export const ContainerSwitch = styled.div`
  background: var(--background-color-sefaz);
  box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);
  width: 100px;
  margin: 10px;

  .info {
    padding: 5px;
  }

  h1 {
    margin: 0;
    text-transform: uppercase;
    text-align: center;
  }

  p {
    font-weight: normal;
    margin: 0;
    text-align: center;
  }

  input[type='color'] {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: none;
    border: 0;
    cursor: pointer;
    margin: auto;
    height: 100px;
    padding: 0;
    width: 100px;
  }
`;
